import { render } from "./store_write_code_down.vue?vue&type=template&id=1edca878"
import script from "./store_write_code_down.vue?vue&type=script&lang=js"
export * from "./store_write_code_down.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__